<template>
  <el-dialog
    :title="dialogTitle"
    :visible="visible"
    width="600px"
    :before-close="handleClose"
    @close="handleDialogClose"
    class="adjust-price-dialog"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    custom-class="custom-dialog"
  >
    <div class="price-content">
      <!-- 职业基础价格 -->
      <div class="price-item">
        <div class="item-label">职业基础价格</div>
        <div class="item-value">{{ priceData.occupationPrice }} 元/小时</div>
      </div>

      <!-- 工作年限 -->
      <div class="price-item">
        <div class="item-label">
          工作年限
          <!-- <span class="current-value">(当前: {{ formatRatio(currentWorkYearsPriceRatio) }})</span> -->
          <!-- <span class="range-info">[{{ workYearsRangeText }}]</span> -->
        </div>
        <div class="item-value">
          <el-select v-model="formData.workYearsPriceRatio" placeholder="请选择" class="ratio-select">
            <el-option
              v-for="item in workYearsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <!-- 所在城市 -->
      <div class="price-item">
        <div class="item-label">
          所在城市
          <!-- <span class="current-value">(当前: {{ formatRatio(currentAreaPriceRatio) }})</span> -->
        </div>
        <div class="item-value">
          <el-select v-model="formData.areaPriceRatio" placeholder="请选择" class="ratio-select">
            <el-option
              v-for="item in areaOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <!-- 名企经历 -->
      <div class="price-item">
        <div class="item-label">
          名企经历
          <!-- <span class="current-value">(当前: {{ formatRatio(currentWorkedFamousCompanyPriceRatio) }})</span> -->
        </div>
        <div class="item-value">
          <el-select v-model="formData.workedFamousCompanyPriceRatio" placeholder="请选择" class="ratio-select">
            <el-option
              v-for="item in famousCompanyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <!-- 个人能力 -->
      <div class="price-item">
        <div class="item-label">
          个人能力
          <!-- <span class="current-value">(当前: {{ formatRatio(currentAbilityPriceRatio) }})</span> -->
        </div>
        <div class="item-value">
          <el-select v-model="formData.abilityPriceRatio" placeholder="请选择" class="ratio-select">
            <el-option
              v-for="item in abilityOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button type="text" class="apply-btn" @click="handleApplyAssessment">
            申请评定
          </el-button>
          <el-tooltip
            content="如果自认个人能力超过同等条件下的其它同行，可以申请评定（但前提是至少要先完成3单的被预约的预约单）。评定时全倾会约其它专业人员，通过腾讯会议对您进行能力评估（到时您需要支付100元的评定费用给他)，结果如果确实超出，则可在此项获得最高30%的可浮动范围）"
            placement="top"
            :show-after="200"
            :hide-after="0"
            popper-class="assessment-tooltip"
            class="tooltip-icon"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div>
      </div>

      <!-- 自由调节 -->
      <div class="price-item">
        <div class="item-label">
          自由调节
          <!-- <span class="current-value">(当前: {{ formatRatio(currentFreeAdjustPriceRatio) }})</span> -->
        </div>
        <div class="item-value">
          <el-select v-model="formData.freeAdjustPriceRatio" placeholder="请选择" class="ratio-select">
            <el-option
              v-for="item in freeAdjustOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleAdjust" :loading="adjusting" class="submit-btn">
        调整
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {getPriceSetting, setPriceSetting, submitAbilityAssessmentApplication} from '../../api/consultingService'

export default {
  name: 'AdjustPriceDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    consultantId: {
      type: [String, Number],
      required: true
    },
    consultantInfo: {
      type: Object,
      default: () => ({})
    },
    workYears: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      adjusting: false,
      priceData: {
        consultantId: null,
        occupationPrice: 0,
        workYearsPriceRatio: [],
        areaPriceRatio: [],
        workedFamousCompanyPriceRatio: [],
        abilityPriceRatio: [],
        freeAdjustPriceRatio: []
      },
      formData: {
        workYearsPriceRatio: 0,
        areaPriceRatio: 0,
        workedFamousCompanyPriceRatio: 0,
        abilityPriceRatio: 0,
        freeAdjustPriceRatio: 0
      },
      currentFreeAdjustPriceRatio: 0, // 当前自由调节比例
      currentAreaPriceRatio: 0, // 当前所在城市比例
      currentWorkYearsPriceRatio: 0, // 当前工作年限比例
      currentWorkedFamousCompanyPriceRatio: 0, // 当前名企经历比例
      currentAbilityPriceRatio: 0, // 当前个人能力比例
      workYearsOptions: [],
      areaOptions: [],
      famousCompanyOptions: [],
      abilityOptions: [],
      freeAdjustOptions: []
    }
  },
  computed: {
    // 弹层标题（带图标）
    dialogTitle() {
      return '调整价格'
    },
    // 是否可以申请评定
    canApplyAssessment() {
      return this.consultantInfo.completedOrderCount >= 3
    },

    // 工作年限范围显示
    workYearsRangeText() {
      // if (this.workYears <= 5) {
      //   return '仅限 + 0%'
      // }

      const ratioArray = this.priceData.workYearsPriceRatio
      if (!ratioArray || ratioArray.length === 0) {
        return '仅限 + 0%'
      }

      const minRatio = Math.min(...ratioArray)
      const maxRatio = Math.max(...ratioArray)

      if (minRatio === maxRatio) {
        return `仅限 ${minRatio >= 0 ? '+' : ''}${minRatio}%`
      }

      return `${minRatio >= 0 ? '+' : ''}${minRatio}% ~ ${maxRatio >= 0 ? '+' : ''}${maxRatio}%`
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      try {
        this.loading = true
        await this.fetchPriceSetting()
        this.generateOptions()
      } catch (error) {
        console.error('获取价格设置失败:', error)
        this.$message.error(error)
      } finally {
        this.loading = false
      }
    },

    // 获取价格设置
    async fetchPriceSetting() {
      const res = await getPriceSetting({consultantId: this.consultantId})
      if (res.code === 200) {
        this.priceData = res.data
        // 设置当前选中的值（使用API返回的current字段）
        this.formData = {
          workYearsPriceRatio: this.priceData.currentWorkYearsPriceRatio || 0,
          areaPriceRatio: this.priceData.currentAreaPriceRatio || 0,
          workedFamousCompanyPriceRatio: this.priceData.currentWorkedFamousCompanyPriceRatio || 0,
          abilityPriceRatio: this.priceData.currentAbilityPriceRatio || 0,
          freeAdjustPriceRatio: this.priceData.currentFreeAdjustPriceRatio || 0
        }

        // 设置所有当前比例值
        this.currentWorkYearsPriceRatio = this.priceData.currentWorkYearsPriceRatio || 0
        this.currentAreaPriceRatio = this.priceData.currentAreaPriceRatio || 0
        this.currentWorkedFamousCompanyPriceRatio = this.priceData.currentWorkedFamousCompanyPriceRatio || 0
        this.currentAbilityPriceRatio = this.priceData.currentAbilityPriceRatio || 0
        this.currentFreeAdjustPriceRatio = this.priceData.currentFreeAdjustPriceRatio || 0
      } else {
        this.$message.error(res.msg || '获取价格设置失败')
      }
    },

    // 生成选项
    generateOptions() {
      // 工作年限选项 - 根据工作年限动态生成
      this.workYearsOptions = this.generateWorkYearsOptions()

      // 所在城市选项
      this.areaOptions = this.generateRatioOptions(this.priceData.areaPriceRatio, this.formData.areaPriceRatio)

      // 名企经历选项
      this.famousCompanyOptions = this.generateRatioOptions(
        this.priceData.workedFamousCompanyPriceRatio,
        this.formData.workedFamousCompanyPriceRatio
      )

      // 个人能力选项
      this.abilityOptions = this.generateRatioOptions(this.priceData.abilityPriceRatio, this.formData.abilityPriceRatio)

      // 自由调节选项
      this.freeAdjustOptions = this.generateRatioOptions(
        this.priceData.freeAdjustPriceRatio,
        this.formData.freeAdjustPriceRatio
      )
    },

    // 生成工作年限选项
    generateWorkYearsOptions() {
      // 如果工作年限不超过5年，只显示 + 0%
      // 如果工作年限超过5年，使用后台配置的浮动范围
      const ratioArray = this.priceData.workYearsPriceRatio
      if (!ratioArray || ratioArray.length === 0) {
        const defaultOptions = [{value: 0, label: '+ 0%'}]
        // 如果当前值不在默认选项中，添加当前值
        if (
          this.formData.workYearsPriceRatio !== 0 &&
          !defaultOptions.some(opt => opt.value === this.formData.workYearsPriceRatio)
        ) {
          defaultOptions.push({
            value: this.formData.workYearsPriceRatio,
            label: this.formatRatio(this.formData.workYearsPriceRatio)
          })
        }
        return defaultOptions
      }

      const options = ratioArray.map(ratio => {
        const sign = ratio >= 0 ? '+' : ''
        return {
          value: ratio,
          label: `${sign} ${ratio}%`
        }
      })

      // 如果当前值不在选项中，添加当前值
      if (!options.some(opt => opt.value === this.formData.workYearsPriceRatio)) {
        options.push({
          value: this.formData.workYearsPriceRatio,
          label: this.formatRatio(this.formData.workYearsPriceRatio)
        })
      }

      return options
    },

    // 生成比例选项
    generateRatioOptions(ratioArray, currentValue = null) {

      if (!ratioArray || ratioArray.length === 0) {
        const defaultOptions = [{value: 0, label: '+ 0%'}]
        // 如果当前值不为null且不在默认选项中，添加当前值
        if (currentValue !== null && currentValue !== 0 && !defaultOptions.some(opt => opt.value === currentValue)) {
          defaultOptions.push({
            value: currentValue,
            label: this.formatRatio(currentValue)
          })
        }
        return defaultOptions
      }

      const options = ratioArray.map(ratio => {
        const sign = ratio >= 0 ? '+' : ''
        return {
          value: ratio,
          label: `${sign} ${ratio}%`
        }
      })

      // 如果当前值不在选项中，添加当前值
      if (currentValue !== null && !options.some(opt => opt.value === currentValue)) {
        options.push({
          value: currentValue,
          label: this.formatRatio(currentValue)
        })
      }

      return options
    },

    // 格式化比例显示
    formatRatio(ratio) {
      if (ratio === 0) return '0%'
      const sign = ratio >= 0 ? '+' : ''
      return `${sign}${ratio}%`
    },

    // 处理申请评定
    handleApplyAssessment() {
      // if (!this.canApplyAssessment) {
      //   this.$message.warning('至少要先完成3单的被预约的预约单')
      //   return
      // }

      this.$confirm('请先关注右侧小问号处的提示。确定要申请评定吗？', '申请评定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const res = await submitAbilityAssessmentApplication({
              consultantId: this.consultantId
            })

            if (res.code === 200) {
              this.$message.success('申请评定已提交')
            } else {
              this.$message.error(res.msg || '申请评定失败')
            }
          } catch (error) {
            console.error('申请评定失败:', error)
            this.$message.error('申请评定失败，请重试')
          }
        })
        .catch(() => {
          // 用户取消
        })
    },

    // 计算最终价格
    calculateFinalPrice() {
      const basePrice = this.priceData.occupationPrice
      const ratios = [
        this.formData.workYearsPriceRatio,
        this.formData.areaPriceRatio,
        this.formData.workedFamousCompanyPriceRatio,
        this.formData.abilityPriceRatio,
        this.formData.freeAdjustPriceRatio
      ]

      // 累乘计算
      let finalPrice = basePrice
      ratios.forEach(ratio => {
        finalPrice = finalPrice * (1 + ratio / 100)
      })

      // 四舍五入取整
      return Math.round(finalPrice)
    },

    // 处理调整
    async handleAdjust() {
      try {
        // 验证数据合法性
        // const validationResult = this.validateRatios()
        // if (!validationResult.valid) {
        //   this.$message.error(
        //     `${validationResult.invalidFields.join(
        //       '、'
        //     )} 行设定的值超出允许的范围，请重新选择，或重新打开本弹层刷新数据后再重新选择`
        //   )
        //   return
        // }

        // 确认对话框
        // const finalPrice = this.calculateFinalPrice()
        // await this.$confirm(`调整后的小时价格为：${finalPrice} 元/小时，确定要调整吗？`, '确认调整', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // })

        // this.adjusting = true

        // 提交数据
        const submitData = {
          consultantId: this.consultantId,
          workYearsPriceRatio: this.formData.workYearsPriceRatio,
          areaPriceRatio: this.formData.areaPriceRatio,
          workedFamousCompanyPriceRatio: this.formData.workedFamousCompanyPriceRatio,
          abilityPriceRatio: this.formData.abilityPriceRatio,
          freeAdjustPriceRatio: this.formData.freeAdjustPriceRatio
        }

        const res = await setPriceSetting(submitData)

        if (res.code === 200) {
          this.$message.success('价格调整成功')
          // 更新所有当前比例值
          this.currentWorkYearsPriceRatio = this.formData.workYearsPriceRatio
          this.currentAreaPriceRatio = this.formData.areaPriceRatio
          this.currentWorkedFamousCompanyPriceRatio = this.formData.workedFamousCompanyPriceRatio
          this.currentAbilityPriceRatio = this.formData.abilityPriceRatio
          this.currentFreeAdjustPriceRatio = this.formData.freeAdjustPriceRatio
          this.$emit('adjustSuccess', {
            // finalPrice,
            ratios: this.formData
          })
          this.handleClose()
        } else {
          this.$message.error(res.msg || '价格调整失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('价格调整失败:', error)
          this.$message.error(error)
        }
      } finally {
        this.adjusting = false
      }
    },

    // 验证比例合法性
    validateRatios() {
      const invalidFields = []

      // 验证工作年限
      if (!this.isRatioValid(this.formData.workYearsPriceRatio, this.priceData.workYearsPriceRatio)) {
        invalidFields.push('工作年限')
      }

      // 验证所在城市
      if (!this.isRatioValid(this.formData.areaPriceRatio, this.priceData.areaPriceRatio)) {
        invalidFields.push('所在城市')
      }

      // 验证名企经历
      if (
        !this.isRatioValid(this.formData.workedFamousCompanyPriceRatio, this.priceData.workedFamousCompanyPriceRatio)
      ) {
        invalidFields.push('名企经历')
      }

      // 验证个人能力
      if (!this.isRatioValid(this.formData.abilityPriceRatio, this.priceData.abilityPriceRatio)) {
        invalidFields.push('个人能力')
      }

      // 验证自由调节
      if (!this.isRatioValid(this.formData.freeAdjustPriceRatio, this.priceData.freeAdjustPriceRatio)) {
        invalidFields.push('自由调节')
      }

      return {
        valid: invalidFields.length === 0,
        invalidFields
      }
    },

    // 检查比例是否在允许的选项列表中
    isRatioValid(selectedRatio, allowedOptions) {
      if (!allowedOptions || allowedOptions.length === 0) {
        return selectedRatio === 0
      }

      return allowedOptions.includes(selectedRatio)
    },

    // 处理弹窗关闭事件
    handleDialogClose() {
      this.$emit('update:visible', false)
    },

    // 关闭弹窗
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .custom-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    padding: 24px 40px 20px;
    border-bottom: none;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;
      gap: 8px;

      &::before {
        content: '';
        display: inline-block;
        width: 24px;
        height: 24px;
        background-image: url('/img/tiaozheng.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
    }

    .el-dialog__headerbtn {
      top: 24px;
      right: 40px;
    }
  }

  .el-dialog__body {
    padding: 24px 40px;
  }

  .el-dialog__footer {
    padding: 20px 40px 32px;
    border-top: none;
  }
}

.adjust-price-dialog {
  .price-content {
    .price-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 0;
      border-bottom: none;

      .item-label {
        font-size: 16px;
        color: #333;
        font-weight: 500;
        min-width: 120px;

        .current-value {
          font-size: 12px;
          color: #999;
          font-weight: normal;
          margin-left: 8px;
        }

        .range-info {
          font-size: 11px;
          color: #666;
          font-weight: normal;
          margin-left: 4px;
          background-color: #f5f5f5;
          padding: 2px 6px;
          border-radius: 3px;
        }
      }

      .item-value {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;
        justify-content: flex-end;

        .ratio-select {
          width: 160px;
        }

        .apply-btn {
          padding: 6px 12px;
          font-size: 14px;
          color: #409eff;
          border: 1px solid #409eff;
          border-radius: 4px;
          background: #fff;

          &:hover {
            background: #409eff;
            color: #fff;
          }
        }

        .tooltip-icon {
          color: #999;
          cursor: help;
          font-size: 16px;

          &:hover {
            color: #409eff;
          }
        }
      }
    }
  }

  .dialog-footer {
    text-align: center;
    padding: 0;

    .submit-btn {
      width: 60%;
      height: 48px;
      font-size: 18px;
      font-weight: 500;
      border-radius: 8px;
      background: #5ad3cd;
      border-color: #5ad3cd;

      &:hover {
        background: #4ab8b2;
        border-color: #4ab8b2;
      }
    }
  }
}

// 申请评定提示框样式优化
::v-deep .assessment-tooltip {
  max-width: 100px !important;
  word-wrap: break-word;
  line-height: 1.6;
  font-size: 13px;

  .el-tooltip__popper {
    max-width: 100px !important;
  }
}
</style>
